import { useEffect, useState } from "react";
import { useNotify } from "react-admin";
import { API_BASE_URL_ADMIN } from "shared/config";
import { API_URL } from "shared/constants/api-url";
import { ERROR_MSG } from "shared/constants/error-msg";
import { httpClient } from "shared/services/http-client";
import { isForbiddenError } from "shared/utils/errors";

interface Arguments {
  companyId: string;
}

export const useGetCompanyGroups = ({ companyId }: Arguments) => {
  const [isLoading, setIsLoading] = useState(false);
  const [groups, setGroups] = useState<string[]>([]);
  const notify = useNotify();

  const url = API_URL.getCompanyGroups(companyId);

  const fetchCompanyGroups = () => {
    setIsLoading(true);

    return httpClient(`${API_BASE_URL_ADMIN}${url}`, {
      method: 'GET',
    })
    .then((response) => {
      const groups = response.json.groups;

      setGroups(groups);

      return groups;
    })
    .catch((error) => {
      let msg = error.message || ERROR_MSG.internal

      if (isForbiddenError(error)) {
        msg = ERROR_MSG.forbidden
      }

      notify(msg, { type: 'error' });
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchCompanyGroups();
  }, []);

  return { fetchCompanyGroups, isLoading, groups };
};